'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:AppSettingService
 * @description
 * # AppSettingService
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('AppSetting', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_ACTIVITY_URL = domain.name + '/api/v1/app_settings/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_ACTIVITY_URL,
      baseModelName: 'app_setting'
    });

    baseService.getAppSettings = function() {
      return $http.get(BASE_ACTIVITY_URL + 'id').then((response) => {
        sessionStorage.setItem('default_customer_id', response.data.default_customer_id);
        sessionStorage.setItem('default_customer_name', response.data.default_customer_name);
      }).catch(error => {
        console.error(error);
      });
    };

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    return baseService;
  }]);
